import { render, staticRenderFns } from "./SubtabWarden.vue?vue&type=template&id=a5029b26&scoped=true"
import script from "./SubtabWarden.vue?vue&type=script&lang=js"
export * from "./SubtabWarden.vue?vue&type=script&lang=js"
import style0 from "./SubtabWarden.vue?vue&type=style&index=0&id=a5029b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5029b26",
  null
  
)

export default component.exports